<div class="form-group">
  <!--added by Juber --- start -->
  @if (!templateForPermitForm) {
    <wm-de-label [entity]="entity" [for]="entity.templateCode"></wm-de-label>
    <input
      type="text"
      readonly
      class="form-control-plaintext"
      [id]="entity.templateCode"
      [value]="this.todaysDate"
    />
  }
  @else {
    <div class="free-form-text-style">
      <wm-common-text
        [data]="{text: entity.label}"
        class="entity-text"

      >
      </wm-common-text>
      <wm-common-text
        [data]="{
          text: todaysDate || ''
        }"
      >
      </wm-common-text>
    </div>
  }
    <!--added by Juber --- end -->
</div>
